const control_label_css_for_handlebars = `.{{sid}} .component-head-container {
  font-size: {{label_font_size}}{{label_font_size_unit}};
  font-weight: {{label_font_weight}};
  color: {{label_text_color}};
  text-align: {{label_text_alignment}};
}
.{{sid}} [actionable]{
  cursor:pointer;
}`;

function sandboxCssWithCustomClass(styleText, action = '') {
  var dataToProcess = '.dhq_custom_cid {' + styleText + '}';
  return new Promise(function(resolve, reject) {
    try {
      var sass = new Sass();
      var output = '';
      sass.compile(dataToProcess, function(result) {
        output = result;
        if (output.status == 0) {
          output.text == null ? (output.text = '') : false;
          if (action == 'handlebars') {
            output.text = output.text + control_label_css_for_handlebars;
            output.text = output.text
              .replace(/dhq_custom_cid/gm, '{{sid}}')
              .replace(/\.{{sid}}\s?\.w769-1024/gm, '.w769-1024 .{{sid}}')
              .replace(/\.{{sid}}\s?\.w641-768/gm, '.w641-768 .{{sid}}')
              .replace(/\.{{sid}}\s?\.w320-640/gm, '.w320-640 .{{sid}}');
          } else {
            output.text = output.text
              .replace(/dhq_custom_cid/gm, '<%= rf.get("cid") %>')
              .replace(
                /\.<%= rf\.get\("cid"\) %>\s?\.w769-1024/gm,
                '.w769-1024 .<%= rf.get("cid") %>'
              )
              .replace(
                /\.<%= rf\.get\("cid"\) %>\s?\.w641-768/gm,
                '.w641-768 .<%= rf.get("cid") %>'
              )
              .replace(
                /\.<%= rf\.get\("cid"\) %>\s?\.w320-640/gm,
                '.w320-640 .<%= rf.get("cid") %>'
              );
          }
          resolve({
            success: true,
            resp: output
          });
        } else {
          resolve({
            success: false,
            resp: output.message
          });
        }
      });
    } catch (ex) {
      resolve({
        success: false,
        Error: ex
      });
    }
  });
}
export default {
  processCSS: sandboxCssWithCustomClass
};
